var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenFor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_11175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75H7M1 8.75V3.75C1 1.75 1.5 1.25 3.5 1.25M11 8.75V3.75C11 1.75 10.5 1.25 8.5 1.25",
    stroke: "#1E1E2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.95469V9.59969C5 10.5997 4.6 10.9997 3.6 10.9997H2.4C1.4 10.9997 1 10.5997 1 9.59969V7.95469C1 6.95469 1.4 6.55469 2.4 6.55469H3.6C4.6 6.55469 5 6.95469 5 7.95469ZM11 7.95469V9.59969C11 10.5997 10.6 10.9997 9.6 10.9997H8.4C7.4 10.9997 7 10.5997 7 9.59969V7.95469C7 6.95469 7.4 6.55469 8.4 6.55469H9.6C10.6 6.55469 11 6.95469 11 7.95469Z",
    stroke: "#1E1E2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_11175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFor);
export default __webpack_public_path__ + "static/media/openFor.bcd1d99454c8adda4bc2a316b052bdbf.svg";
export { ForwardRef as ReactComponent };